import { Draft } from 'immer';

export function calcMonthlyCareInputs(mutableClient: Draft<Client>) {
  const { phaseCarePlans } = mutableClient.projectionInputs;
  const monthlyCareInputs: MonthlyCareInput[] = [];
  let globalMonthIndex = 0;

  phaseCarePlans.forEach(plan => {
    const monthsInPhase = Math.round(plan.phaseCareMonthsNeeded);

    if (monthsInPhase === 0) return;

    const monthlyHours = plan.phaseCareHoursNeeded / monthsInPhase;

    for (let monthsIntoPhase = 0; monthsIntoPhase < monthsInPhase; monthsIntoPhase++) {
      monthlyCareInputs.push({
        monthIndex: globalMonthIndex,
        carePhase: plan.carePhase,
        monthsIntoPhase,
        careHours: Math.round(monthlyHours),
        nonAdlEligibleDays: 0,
        adlEligibleDays: 0,
        coverageEligibleDays: 0,
        waitingPeriodDaysConsumedHome: 0,
        waitingPeriodDaysConsumedFacility: 0,
      });
      globalMonthIndex++;
    }
  });

  mutableClient.projectionInputs.monthlyCareInputs = monthlyCareInputs;
}
